export default {
  pageHeroV1: {
    container: {
      height: '85vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      alignItems: 'center',
      justifyContent: 'center'
    },

    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      h1: {
        fontSize: ['2.5rem', '', '4.5rem'],
        marginBottom: 1,
        letterSpacing: '3px',
        // textTransform: 'uppercase',
        borderColor: 'secondary',
        // backgroundColor: 'rgba(0,0,0,0.35)',
        padding: '1rem',
        fontFamily: 'heading',
        fontWeight: 'normal',
        color: 'light'
      },
      h2: {
        marginBottom: 4
      }
    }
  }
}
